import { render, staticRenderFns } from "./HeaderNotification.vue?vue&type=template&id=18d66908&scoped=true&"
import script from "./HeaderNotification.vue?vue&type=script&lang=js&"
export * from "./HeaderNotification.vue?vue&type=script&lang=js&"
import style0 from "./HeaderNotification.vue?vue&type=style&index=0&id=18d66908&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d66908",
  null
  
)

export default component.exports